import { CartLineAttribute } from './types';

export const RESTRICTED_URL_PARAMS = [
  'currency',
  'type',
  'product',
  'affiliateDiscountCode',
  'affiliateName',
  'affiliateDiscountPercentage',
  'affiliateImage',
];

export function extractUrlAttributeParams(search: string): CartLineAttribute[] {
  const params = new URLSearchParams(search);
  const out: CartLineAttribute[] = [];
  for (const [key, value] of params.entries()) {
    if (!RESTRICTED_URL_PARAMS.includes(key) && value) {
      out.push({ key, value });
    }
  }
  return out;
}

export function mergeAttributes(
  existing: CartLineAttribute[] | undefined,
  urlParams: CartLineAttribute[] | undefined,
): CartLineAttribute[] {
  const merged = new Map<string, string>();
  for (const attr of existing ?? []) {
    merged.set(attr.key, attr.value);
  }
  for (const param of urlParams ?? []) {
    if (!RESTRICTED_URL_PARAMS.includes(param.key) && param.value) {
      merged.set(param.key, param.value);
    }
  }
  return Array.from(merged, ([key, value]) => ({ key, value }));
}
